import styled from 'styled-components'

export const ProductPanel = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding: 96px 0;
  max-width: 1920px;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 0;
  }
  .leftPanel {
    padding: 24px 24px 24px 40px;
    width: 260px;
    position: sticky;
    top: 65px;

    ${({ theme }) => theme.breakpoints.down('md')} {
      padding-left: 16px;
      padding-right: 0;
    }
    ${({ theme }) => theme.breakpoints.down('sm')} {
      padding-top: 60px;
      top: 82px;
    }
    ${({ theme }) => theme.breakpoints.down('xs')} {
      display: none;
    }

    .LeftNav {
      height: calc(100vh - 89px);
      overflow-y: scroll;

      ${({ theme }) => theme.breakpoints.down('sm')} {
        height: calc(100vh - 142px);
      }
    }

    ul {
      padding-top: 24px;
      li {
        display: flex;
        border-left: 2px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[25]};
        gap: 4px;
        margin-bottom: 16px;

        a {
          color: ${({ theme }) => theme.webMktNewPalette.deepBlue[55]};
          padding: 8px 0 8px 8px;
          font-size: 14px;
          line-height: 24px;
          font-weight: 400;
          :hover {
            color: ${({ theme }) => theme.webMktNewPalette.black};
          }
        }
      }
      :hover {
        border-left-color: ${({ theme }) => theme.webMktNewPalette.orange[50]};
        color: ${({ theme }) => theme.webMktNewPalette.black};
      }
      .active {
        border-left: 2px solid ${({ theme }) => theme.webMktNewPalette.orange[50]};
        color: ${({ theme }) => theme.webMktNewPalette.black};
        a {
          color: ${({ theme }) => theme.webMktNewPalette.black};
        }
      }
    }
    ${({ theme }) => theme.breakpoints.down('xs')} {
      display: none;
    }
  }
  .rightPanel {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: calc(100% - 260px);
    ${({ theme }) => theme.breakpoints.down('sm')} {
      width: 100%;
    }
    .MediaTextVariant {
      ${({ theme }) => theme.breakpoints.down('sm')} {
        width: calc(100% - 16px);
      }
      ${({ theme }) => theme.breakpoints.down('xs')} {
        width: 100%;
      }
    }

    .featuredResource {
      width: 100%;
    }

    .resourceRow--fullWidth {
      width: 100%;
      .ResourceRow__CTA-Container {
        text-align: left;
        ${({ theme }) => theme.breakpoints.down('xs')} {
          text-align: center;
        }
      }
      .ResourceRow__Card-Container {
        padding-bottom: 10px;
        .ResourceRow__Item {
          position: relative;
          .ResourceRow__Image-Container {
            height: 312px;
            .ResourceRow__Pill-Container {
              display: none;
            }
            .ResourceRow__CtaBox {
              position: absolute;
              bottom: 0px;
              padding: 24px;
              .CTA {
                padding: 12px 12px;
                margin: 0;
                height: 40px;
                line-height: normal;
                .CTA__Arrow-Container {
                  margin-left: 0;
                  width: 16px;
                  height: 16px;
                  svg {
                    width: 16px;
                    height: 16px;
                  }
                }
              }
            }
          }
          .ResourceRow__Text-Container {
            margin: 24px 0;
            .CTA {
              display: none;
            }
            .ResourceRow__Meta-Container {
              p {
                font-size: 16px;
                font-weight: 700;
                line-height: 20px;
              }
            }
            .ResourceRow__Item-Heading {
              font-size: 24px;
              line-height: 32px;
              margin: 32px 0;
            }
            .ResourceRow__Item-Body {
              margin: 0 0 24px 0;
              p {
                font-size: 16px;
                line-height: 24px;
              }
            }
          }

          .noMediaContainer {
            min-height: 224px;
            position: static;
            padding-bottom: 40px;
            .CTA {
              display: block;
              margin-bottom: 16px;
            }
            .noMedia {
              width: 40px;
              position: absolute;
              bottom: 24px;
              .CTA {
                padding: 12px 12px;
                margin: 0;
                height: 40px;
                line-height: normal;
                .CTA__Arrow-Container {
                  margin-left: 0;
                  width: 16px;
                  height: 16px;
                  svg {
                    width: 16px;
                    height: 16px;
                  }
                }
              }
            }
          }
        }
      }
    }

    .IconText__fullWidth {
      background: transparent;
    }

    .MediaText--fullWidth {
      width: 100%;
      background-color: ${({ theme }) => theme.webMktNewPalette.white};
    }
    .ParagraphBlock--fullWidth {
      display: flex;
      align-items: flex-start;
      width: 100%;
      flex-direction: row;
      justify-content: flex-start;
      ${({ theme }) => theme.breakpoints.down('sm')} {
        flex-direction: column;
      }

      .fullwidth__featuredAsset {
        position: relative;
        width: 100%;
        margin: 64px 0px;
        ${({ theme }) => theme.breakpoints.down('sm')} {
          margin: 0;
        }
        .FeaturedAsset {
          margin-top: 48px;
          display: flex;
          justify-content: flex-end;
          ${({ theme }) => theme.breakpoints.down('sm')} {
            margin-top: 0;
            padding-right: 16px;
          }
          .absolute {
            top: 0;
            position: relative;
            ${({ theme }) => theme.breakpoints.down('lg')} {
              max-width: 280px;
              min-width: 280px;
            }
            ${({ theme }) => theme.breakpoints.down('md')} {
              max-width: 280px;
              min-width: 280px;
            }
            ${({ theme }) => theme.breakpoints.down('sm')} {
              position: relative;
              right: auto;
              max-width: calc(100% - 16px);
              min-width: calc(100% - 16px);
              left: 0;
              box-shadow: none;
            }
            .FeaturedAsset__Desc {
              display: block;
            }
          }
        }
      }

      .ParagraphBlock__Container {
        max-width: 796px;
        ${({ theme }) => theme.breakpoints.down('lg')} {
          max-width: calc(100% - 400px);
        }

        ${({ theme }) => theme.breakpoints.down('md')} {
          max-width: calc(100% - 350px);
          padding-left: 24px;
          padding-right: 24px;
        }

        ${({ theme }) => theme.breakpoints.down('sm')} {
          max-width: calc(100% - 32px);
          margin-top: 100px;
          padding-left: 16px;
          padding-right: 16px;
        }
        .MuiContainer-root {
          padding: 0;
        }
        .ParagraphBlock__Body {
          p {
            font-size: 20px;
            line-height: 32px;
            letter-spacing: -0.5px;
          }
        }
      }
    }

    .ParagraphBlock__Container {
      ${({ theme }) => theme.breakpoints.down('sm')} {
        max-width: 100%;
      }
    }
  }
`
